import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const heroSlides = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20collage%20with%20dramatic%20lighting%2C%20film%20reel%20texture%20overlay%2C%20dark%20theater%20atmosphere%2C%20warm%20golden%20spotlight%2C%20movie%20posters%20silhouettes%2C%20professional%20cinema%20aesthetic%2C%20deep%20contrast%2C%20artistic%20film%20photography%20style&width=1920&height=900&seq=hero-slide-01&orientation=landscape',
    title: '战狼3：终极使命',
    subtitle: '吴京导演力作 · 铁血归来',
    link: '/article/1',
    tag: '热映中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20epic%20scene%20with%20giant%20planet%20and%20starships%2C%20nebula%20colors%2C%20film%20grain%20texture%2C%20dark%20cosmic%20background%2C%20dramatic%20lighting%2C%20movie%20theater%20aesthetic%2C%20professional%20sci-fi%20cinematography&width=1920&height=900&seq=hero-slide-02&orientation=landscape',
    title: '流浪地球3：新家园',
    subtitle: '科幻巨制 · 开启全新篇章',
    link: '/article/2',
    tag: '热映中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20war%20epic%20cinematic%20scene%20with%20thousands%20of%20soldiers%20in%20armor%2C%20dramatic%20sky%20with%20fire%20and%20smoke%2C%20film%20grain%2C%20golden%20and%20crimson%20lighting%2C%20professional%20movie%20cinematography%2C%20dark%20epic%20atmosphere&width=1920&height=900&seq=hero-slide-03&orientation=landscape',
    title: '封神第二部：战火西岐',
    subtitle: '神话史诗 · 震撼上映',
    link: '/article/5',
    tag: '热映中',
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden">
      {heroSlides.map((s, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-50 text-xs font-medium mb-4">
              {slide.tag}
            </span>
            <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-50 mb-3 leading-tight">
              {slide.title}
            </h2>
            <p className="text-base md:text-lg text-foreground-300 mb-6">
              {slide.subtitle}
            </p>
            <Link
              to={slide.link}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-play-circle-fill"></i>
              </div>
              立即观看
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              idx === current
                ? 'w-6 bg-primary-500'
                : 'bg-foreground-50/40 hover:bg-foreground-50/60'
            }`}
            aria-label={`切换到第 ${idx + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}